import { grey } from '@mui/material/colors';
import { createStyles, makeStyles } from '@mui/styles';
import { NumberMultipleCheckboxCellProps } from './NumberMultipleCheckbox.props';

const sharedRootProps = {
  width: '100%',
  '&& .MuiCheckbox-root': {
    padding: '0px 16px 0px 3px',
  },
};

// Use createStyles and makeStyles with theme and NumberMultipleCheckboxCellProps
const useNumberMultipleCheckboxStyles = makeStyles(({
  isEditableTitleCell = false,
  rightAlignContent = false,
}: NumberMultipleCheckboxCellProps) =>
  createStyles({
    root: {
      ...sharedRootProps,
    },
    controlLabelRoot: {
      ...sharedRootProps,
      flexDirection: 'row-reverse',
      ...(isEditableTitleCell && { margin: 0 }),
      justifyContent: isEditableTitleCell && !rightAlignContent ? 'space-between' : 'flex-start',
      '&& .MuiTypography-root': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      },
    },
    strike: {
      textDecoration: 'line-through',
      color: isEditableTitleCell ? grey[500] : grey[700],
    },
    bold: {
      fontWeight: 'bold',
    },
  })
);

export default useNumberMultipleCheckboxStyles;
